module.exports = __webpack_public_path__ + "images/psp/PSPHero/kayak-hero.webp";